// Synexis: viewer interativo da API (Redoc, React). Pack próprio (lazy, só nesta página). Usamos
// Redoc em vez do Scalar porque o Scalar (Vue) conflitava com a versão de Vue da app no webpack.
import React from 'react'
import { createRoot } from 'react-dom/client'
import { RedocStandalone } from 'redoc'

function mountApiReference () {
  const el = document.getElementById('api-reference')

  if (!el || el.dataset.redocMounted) return

  el.dataset.redocMounted = '1'

  createRoot(el).render(
    React.createElement(RedocStandalone, {
      specUrl: el.dataset.specUrl,
      options: { hideDownloadButton: false, expandResponses: '200,201', nativeScrollbars: true }
    })
  )
}

document.addEventListener('turbo:load', mountApiReference)
mountApiReference()
